// @flow
import types from './userConstants';
import { getAsync, patchAsync, postAsync, putAsync, uploadAsync } from '../../../_metronic/helpers/httpClient';
import { enumDiscountScopeType, enumUserType } from '../../../_metronic/helpers';

export const clearState = () => async dispatch => {
    dispatch({
        type: types.CLEAR_STATE
    })
}

export const getUserList = (keyword = '', type = '', isActive = '', isApprove = '') => async dispatch => {

    dispatch({
        type: types.GET_USERS
    })

    const response = await getAsync(`/users?keyword=${keyword}&type=${type}&isActive=${isActive}&isApprove=${isApprove}`);

    if (response.isSuccess) {
        dispatch({
            type: types.GET_USERS_SUCCESS,
            payload: response,
        })
    } else {
        dispatch({
            type: types.GET_USERS_FAILED,
            payload: response,
        })
    }
}

export const changeStatus = (id, isActive) => async dispatch => {

    dispatch({
        type: types.PATCH_USER_STATUS
    })

    var request = {
        isActive: isActive
    };

    const response = await patchAsync(`/users/${id}`, request);

    if (response.isSuccess) {
        dispatch({
            type: types.PATCH_USER_STATUS_SUCCESS,
            payload: { id, isActive }
        })
    } else {
        dispatch({
            type: types.PATCH_USER_STATUS_FAILED,
            payload: id,
        })
    }
}

export const getUser = (id) => async dispatch => {

    dispatch({
        type: types.GET_USER
    })

    const response = await getAsync(`/users/${id}`);

    if (response.isSuccess) {
        dispatch({
            type: types.GET_USER_SUCCESS,
            payload: response
        })
    } else {
        dispatch({
            type: types.GET_USER_FAILED,
            payload: response
        })
    }
}

export const postUser = (user) => async dispatch => {

    dispatch({
        type: types.POST_USER
    })

    const response = await postAsync(`/users`, user);

    if (response.isSuccess) {
        dispatch({
            type: types.POST_USER_SUCCESS,
            payload: response
        })
    } else {
        dispatch({
            type: types.POST_USER_FAILED,
            payload: response
        })
    }
}

export const patchUser = (user) => async dispatch => {

    dispatch({
        type: types.PATCH_USER
    })

    const response = await patchAsync(`/users/${user.id}`, user);

    if (response.isSuccess) {
        dispatch({
            type: types.PATCH_USER_SUCCESS,
            payload: response
        })
    } else {
        dispatch({
            type: types.PATCH_USER_FAILED,
            payload: response
        })
    }
}

export const uploadAvatar = (file) => async dispatch => {

    var request = {
        identifier: file.id,
        fileName: file.name,
        fileExtension: file.extension,
        actionType: file.actionType
    };

    const response = await postAsync(`/signed-url/upload`, request);

    var data = {
        id: file.id,
        file: file.data
    }

    if (response.isSuccess) {
        await uploadAsync(response.data.url, data, () => { });

        dispatch({
            type: types.GET_NEW_AVATAR,
            payload: response.data
        })
    }
}

export const getContact = (id) => async dispatch => {

    dispatch({
        type: types.GET_CONTACT
    })

    const response = await getAsync(`/users/${id}/contact`);

    if (response.isSuccess) {
        dispatch({
            type: types.GET_CONTACT_SUCCESS,
            payload: response
        })
    } else {
        dispatch({
            type: types.GET_CONTACT_FAILED,
            payload: response
        })
    }
}

// Renaming to be clear it's only contact info now, but keeping export name if used elsewhere as generic 'postContact'
export const postContact = (contact) => async dispatch => {
    dispatch({
        type: types.POST_CONTACT
    })

    const contactInfo = {
        company: contact.company,
        email: contact.email,
        phone: contact.phone,
        phoneCode: contact.phoneCode,
        building: contact.building,
        street: contact.street,
        state: contact.state,
        zipCode: contact.zipCode,
        city: contact.city,
        countryId: contact.countryId
    };

    const response = await postAsync(`/users/${contact.userId}/contact-info`, contactInfo);

    if (response.isSuccess) {
        dispatch({
            type: types.POST_CONTACT_SUCCESS,
            payload: response
        })

        dispatch(getContact(contact.userId))
    } else {
        dispatch({
            type: types.POST_CONTACT_FAILED,
            payload: response
        })
    }
}

export const postFinancialDetails = (contact) => async dispatch => {
    dispatch({
        type: types.POST_FINANCIAL_DETAILS
    })

    const financialDetails = {
        btwNumber: contact.btwNumber,
        kvkNumber: contact.kvkNumber,
        iban: contact.iban,
        currency: contact.currency,
        vat: contact.vat
    };

    const response = await postAsync(`/users/${contact.userId}/financial-details`, financialDetails);

    if (response.isSuccess) {
        dispatch({
            type: types.POST_FINANCIAL_DETAILS_SUCCESS,
            payload: response
        })
    } else {
        dispatch({
            type: types.POST_FINANCIAL_DETAILS_FAILED,
            payload: response
        })
    }
}

export const putContact = (contact) => async dispatch => {
    dispatch({
        type: types.PUT_CONTACT
    })

    const contactInfo = {
        company: contact.company,
        email: contact.email,
        phone: contact.phone,
        phoneCode: contact.phoneCode,
        building: contact.building,
        street: contact.street,
        state: contact.state,
        zipCode: contact.zipCode,
        city: contact.city,
        countryId: contact.countryId
    };

    const response = await putAsync(`/users/${contact.userId}/contact/${contact.id}/contact-info`, contactInfo);

    if (response.isSuccess) {
        dispatch({
            type: types.PUT_CONTACT_SUCCESS,
            payload: response
        })
    } else {
        dispatch({
            type: types.PUT_CONTACT_FAILED,
            payload: response
        })
    }
}

export const putFinancialDetails = (contact) => async dispatch => {
    dispatch({
        type: types.PUT_FINANCIAL_DETAILS
    })

    const financialDetails = {
        btwNumber: contact.btwNumber,
        kvkNumber: contact.kvkNumber,
        iban: contact.iban,
        currency: contact.currency,
        vat: contact.vat
    };

    const response = await putAsync(`/users/${contact.userId}/contact/${contact.id}/financial-details`, financialDetails);

    if (response.isSuccess) {
        dispatch({
            type: types.PUT_FINANCIAL_DETAILS_SUCCESS,
            payload: response
        })
    } else {
        dispatch({
            type: types.PUT_FINANCIAL_DETAILS_FAILED,
            payload: response
        })
    }
}

export const getPolicies = () => async dispatch => {

    const response = await getAsync(`/policies`);
    dispatch({
        type: types.GET_POLICIES,
        payload: response,
    })
}

export const getManufacturingPolicyTypes = () => async dispatch => {
    const response = await getAsync(`/users/manufacturing-policy-types`);
    dispatch({
        type: types.GET_MANUFACTURING_POLICY_TYPES,
        payload: response,
    })
}

export const getPersonalDiscount = (userId) => async dispatch => {
    dispatch({
        type: types.GET_PERSONAL_DISCOUNT
    })

    const response = await getAsync(`/discounts/personal-discount/${userId}`);

    if (response.isSuccess) {
        dispatch({
            type: types.GET_PERSONAL_DISCOUNT_SUCCESS,
            payload: response
        })
    } else {
        dispatch({
            type: types.GET_PERSONAL_DISCOUNT_FAILED,
            payload: response
        })
    }
}

export const postPersonalDiscount = (userId, userType, discount) => async dispatch => {

    if (userType !== enumUserType.Dealer) {
        return;
    }

    dispatch({
        type: types.POST_PERSONAL_DISCOUNT
    })

    const discountWithUserScope = {
        ...discount,
        name: `Personal Discount - ${userId}`,
        startDate: new Date().toISOString(),
        isPersonalDiscount: true,
        scopes: [
            {
                scopeType: enumDiscountScopeType.Dealer,
                scopeValue: userId.toString(),
                scopeLabel: `Dealer ${userId}`
            }
        ]
    };

    const response = await postAsync(`/discounts`, discountWithUserScope);

    if (response.isSuccess) {
        dispatch({
            type: types.POST_PERSONAL_DISCOUNT_SUCCESS,
            payload: response
        })
    } else {
        dispatch({
            type: types.POST_PERSONAL_DISCOUNT_FAILED,
            payload: response
        })
    }
}

export const patchPersonalDiscount = (userId, discountId, discount) => async dispatch => {
    dispatch({
        type: types.PATCH_PERSONAL_DISCOUNT
    })

    const discountWithUserScope = {
        type: {
            set: true,
            value: discount.type
        },
        value: {
            set: true,
            value: discount.value
        }
    };

    const response = await patchAsync(`/discounts/${discountId}`, discountWithUserScope);

    if (response.isSuccess) {
        dispatch({
            type: types.PATCH_PERSONAL_DISCOUNT_SUCCESS,
            payload: response
        })
    } else {
        dispatch({
            type: types.PATCH_PERSONAL_DISCOUNT_FAILED,
            payload: response
        })
    }
}
